import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import MusicNoteRoundedIcon from "@mui/icons-material/MusicNoteRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import logo from "../assets/logo/trilLOAN.svg";
import qrCode from "../assets/background/trilloan_qr.png";
import "./SiteChrome.css";

const navItems = [
  { label: "Home", href: "/" },
  { label: "Service", href: "/#services" },
  { label: "Help & Support", href: "/help-center", route: true },
];

const currentYear = new Date().getFullYear();

export function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="tl-header">
      <RouterLink className="tl-brand" to="/" aria-label="trilLOAN home">
        <img src={logo} alt="trilLOAN" />
      </RouterLink>
      <nav className="tl-nav" aria-label="Primary navigation">
        {navItems.map((item) =>
          item.route ? (
            <RouterLink key={item.label} to={item.href}>
              {item.label}
            </RouterLink>
          ) : (
            <a key={item.label} href={item.href}>
              {item.label}
            </a>
          )
        )}
      </nav>
      <button
        className="tl-menu-button"
        type="button"
        aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
        aria-expanded={isMenuOpen}
        onClick={() => setIsMenuOpen((current) => !current)}
      >
        {isMenuOpen ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
      </button>
      <a className="tl-download-pill" href="/#download">
        Download Now
      </a>
      <div className={`tl-mobile-nav${isMenuOpen ? " is-open" : ""}`}>
        {navItems.map((item) =>
          item.route ? (
            <RouterLink key={item.label} to={item.href} onClick={closeMenu}>
              {item.label}
            </RouterLink>
          ) : (
            <a key={item.label} href={item.href} onClick={closeMenu}>
              {item.label}
            </a>
          )
        )}
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="tl-footer">
      <div className="tl-footer-grid">
        <div className="tl-footer-brand">
          <img src={logo} alt="trilLOAN" />
          <p>
            Your trusted financial partner for loans, payments, and financial
            services in the Philippines.
          </p>
          <div className="tl-socials" aria-label="Social links">
            <a href="https://official.paychat.ph/" aria-label="Website">
              <PublicRoundedIcon />
            </a>
            <a href="mailto:support@trilloan.ph" aria-label="Email">
              <EmailOutlinedIcon />
            </a>
            <a href="tel:0270053458" aria-label="Phone">
              <LocalPhoneOutlinedIcon />
            </a>
            <a href="https://www.facebook.com/paychat.official" aria-label="Facebook">
              <FacebookRoundedIcon />
            </a>
            <a href="https://twitter.com/paychat_ph" aria-label="Twitter">
              <TwitterIcon />
            </a>
            <a href="https://www.instagram.com/paychatph/" aria-label="Instagram">
              <InstagramIcon />
            </a>
            <a href="https://www.tiktok.com/" aria-label="TikTok">
              <MusicNoteRoundedIcon />
            </a>
          </div>
        </div>
        <div className="tl-footer-links">
          <h3>Company</h3>
          <RouterLink to="/about-us">About Us</RouterLink>
          <RouterLink to="/partners">Partners</RouterLink>
        </div>
        <div className="tl-footer-links">
          <h3>Support</h3>
          <RouterLink to="/help-center">Help & Support</RouterLink>
          <RouterLink to="/contact-us">Contact Us</RouterLink>
          <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
          <RouterLink to="/terms-and-conditions">Terms of Service</RouterLink>
        </div>
        <div className="tl-qr">
          <span>Scan to download trilLOAN App</span>
          <img src={qrCode} alt="trilLOAN app QR code" />
        </div>
      </div>
      <div className="tl-footer-bottom">
        <p>© {currentYear} trilLOAN. All rights reserved. Licensed by SEC and regulated by AMLC.</p>
      </div>
    </footer>
  );
}
